window.SMTX.recaptcha = (function () {
  var $recaptchaContainer = $('#recaptcha-container');

  if ($recaptchaContainer.length === 0) {
    return;
  }

  var recaptchaWidgetId;
  var callbackOnComplete;
  
  function init() {
    return new Promise((resolve, reject) => {
      var checkGrecaptcha = setInterval(function () {
        if (typeof grecaptcha !== 'undefined' && typeof grecaptcha.render === 'function') {
          clearInterval(checkGrecaptcha);
          resolve();
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkGrecaptcha);
        reject(new Error('grecaptcha not loaded'));
      }, 5000);
    });
  }

  function loadRecaptcha() {
    var siteKey = $recaptchaContainer.data('siteKey');
    
    recaptchaWidgetId = grecaptcha.render('recaptcha-container', {
      sitekey: siteKey,
      size: 'invisible',
      badge: 'bottomleft',
      callback: recaptchaCallback,
      'expired-callback': function () {
        grecaptcha.reset(recaptchaWidgetId); 
      },
      'error-callback': function () {
        grecaptcha.reset(recaptchaWidgetId);
      }
    });
  }

  function recaptchaCallback(token) {
    if (!callbackOnComplete || typeof callbackOnComplete !== 'function') {
      console.log('no callback function provided for recaptchaCallback')
      return;
    }
    
    $.ajax({
      url: '/api/recaptcha/',
      type: 'POST',
      data: { 'g-recaptcha-response': token }
    }).then(function (res) {
      if (res.success) {
        callbackOnComplete();
      } else {
        console.log('reCAPTCHA token is not valid:', res);
      }
    }).catch(function (error) {
      console.error('reCAPTCHA error:', error);
    }).always(function() {
      grecaptcha.reset(recaptchaWidgetId);
    });
  }

  function triggerRecaptcha(cb) {
    callbackOnComplete = cb;
    grecaptcha.execute(recaptchaWidgetId);
  }
  
  const inViewObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      $recaptchaContainer.toggleClass('in-view', entry.isIntersecting);
    });
  });
  
  const target = document.querySelector('#recaptcha-container');
  inViewObserver.observe(target);
  
  init()
    .then(loadRecaptcha)
    .catch((error) => console.error(error));
    
  return {
    triggerRecaptcha,
  };
})();